import { useReturnDetails } from 'pages/exchange-and-return/hooks';
import { Accordion, FabSupport, Loading, Text } from 'components';
import { FontSize, RETURN_STATUSES } from 'commons';
import * as S from './styles';
import { EntrySummary } from '../components';

export function StepReceived() {
  const { returnDetails, validatingReturnDetails } = useReturnDetails();

  if (!returnDetails || validatingReturnDetails) {
    return <Loading />;
  }

  const { consignmentCode, entries, status } = returnDetails;
  const { REFUND_FAILED } = RETURN_STATUSES;

  if (REFUND_FAILED.value === status) {
    return (
      <>
        <Accordion title="Confirmação de recebimento" defaultOpen>
          <S.Main>
            <div>
              <Text size={FontSize.font12} className="error">
                <b>Erro ao estornar!</b> Não foi possível estornar a devolução
                automaticamente, por favor, acione o suporte e informe a
                situação.
              </Text>
            </div>

            {entries.map((summaryEntry, index) => (
              <EntrySummary key={index} summaryEntry={summaryEntry} />
            ))}
          </S.Main>
        </Accordion>

        <FabSupport consignmentCode={consignmentCode} isReturn />
      </>
    );
  }

  return (
    <Accordion title="Confirmação de recebimento" defaultOpen>
      <S.Main>
        <div>
          <Text size={FontSize.font12}>
            <b>Atenção!</b> A devolução do produto abaixo foi confirmada! Um
            e-mail foi enviado ao cliente com o comprovante de estorno anexado e
            informando o prazo de 30 a 60 dias para o estorno.
          </Text>
          <Text size={FontSize.font12}>
            Caso necessário você pode baixar o comprovante de estorno no botão a
            baixo.
          </Text>
        </div>

        {entries.map((summaryEntry, index) => (
          <EntrySummary key={index} summaryEntry={summaryEntry} />
        ))}

        <S.ButtonWrapper>
          <Text size={FontSize.font12} className="text">
            Aguardando comprovante de estorno ficar disponível para download.
          </Text>
        </S.ButtonWrapper>
      </S.Main>
    </Accordion>
  );
}
